import React, { Fragment, useState } from 'react';
import useShowClass from '../../../../Hooks/useShowClass';


const MonthlyChart = () => {
    const NavTab = ['Revenue', 'orders', 'Customers'];
    const DailyDropdown = ["Beer&Ciders", "Wines", "Spirits"];

    const [active, setActive] = useState('Revenue');
    const [show, setShow] = useShowClass('show');
    const activeHandler = (item) => {
        setActive(item);
        setShow('');
    };
    const [startDate, setstartDate] = useState(new Date())
    const handleChange = date => {
        setstartDate(date);
    };

    return (
        <Fragment>


        </Fragment>
    )
}

export default MonthlyChart;